<style>
@import '../../assets/css/transaction.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                <form @submit.prevent="initialize" :submit="initialize">
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date')}}</template>
                        <b-input-group>
                            <b-input-group-text slot="append"><i class='dripicons-calendar'></i></b-input-group-text>
                            <b-form-input type="date" v-model="ajaxSearch.run_at"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_trade_team')}}</template>
                        <b-form-input v-model="ajaxSearch.group_id"></b-form-input>
                    </b-form-group>
                    <!-- <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_trader_team')}}</template>
                        <b-form-select v-model="ajaxSearch.group_id">
                            <option value="">-</option>
                        </b-form-select>
                    </b-form-group> -->
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label"></template>
                        <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                    </b-form-group>
                </form>
            </b-card>
            <b-card :header="$t($route.name)">
                <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                        <template slot="header">
                            <p>{{title.label}}</p>
                            <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                        </template>
                    </el-table-column>
                    <el-table-column type="expand">
                        <b-button variant="primary" size="lg" @click="getEditBonusRate()" v-if="showEdit">{{$t('bonus_rate.table_edit')}}</b-button>
                    </el-table-column>
                </el-table>
                <b-row class="mt-3">
                    <b-col sm="12" md="3" class="pr-0">
                        <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                    </b-col>
                    <b-col sm="12" md="9" class="pl-0">
                        <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <b-modal id="editBonusRate" :title="$t('setting_bonuspayment.table_edit')" size="lg" @ok="editBonusRate" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
            <form id="editBonusRateForm" @submit.prevent="editBonusRate">
                <div class="custom-from-group">
                    <b-form-group label-cols="12" label-cols-lg="4" v-for="(walletList,index) in ajaxEditList.wallet_list" :key="index" name="wallet[]">
                        <template slot="label">{{walletList.code}}</template>
                        <b-form-input :name="'rate[' + walletList.id + ']'" :value="walletList.value"></b-form-input>
                    </b-form-group>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import {bonusRateAjaxTable,getBonusRateEdit,bonusRateEdit} from '@/system/model/bonus_rate'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxToolList:[],
            ajaxSearch:{limit:'',pagination:'',id:'',run_at:'',group_id:'',GCA:'',USDT:'',BTC:'',ETH:'',LTC:'',BCHABC:'',DASH:''},
            ajaxRow:'',
            ajaxEdit:[],
            ajaxEditList:{account_list:[],bonus_list:[],package_list:[],wallet_list:[]},
            ajaxExportStart:'',
            ajaxExportEnd:'',
            statusList:[],
            showEdit: true,
            pageLimit:10,
            ajaxInfo:'',
            errors: [],
            permission:{
                edit:'470D7F'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'50'
            },{
                prop: "run_at",
                label: this.$t('admin.table_date'),
                width:'200'
            },{
                prop: "group_id",
                label: this.$t('admin.table_trade_team'),
                width:'200'
            },{
                prop: "GCA",
                label: "GCA",
                width:'100'
            },{
                prop: "USDT",
                label: "USDT",
                width:'100'
            },{
                prop: "BTC",
                label: "BTC",
                width:'100'
            },{
                prop: "ETH",
                label: "ETH",
                width:'100'
            },{
                prop: "LTC",
                label: "LTC",
                width:'100'
            },{
                prop: "BCHABC",
                label: "BCHABC",
                width:'100'
            },{
                prop: "DASH",
                label: "DASH",
                width:'100'
            }],        
        }
    },methods:{
        initialize(){
            var self = this;
            var result = bonusRateAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.run_at,this.ajaxSearch.group_id,this.ajaxSearch.GCA,this.ajaxSearch.USDT,this.ajaxSearch.BTC,this.ajaxSearch.ETH,this.ajaxSearch.LTC,this.ajaxSearch.BCHABC,this.ajaxSearch.DASH);
            this.preloader(true);
            result.then(function(value){
                if(value.valid){
                    self.preloader(false);
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                    
                }else{
                    self.preloader(false);
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getEditBonusRate(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getBonusRateEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('editBonusRate');
                        self.ajaxEdit = value.data.this_detail;
                        self.ajaxEditList.wallet_list = value.data.wallet_list;
                    }else{
                        var text = "";
                        self.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        self.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },editBonusRate(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                if(this.validate){
                    var form = document.getElementById('editBonusRateForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    formData.append('id', this.ajaxEdit.id); 
                    var result = bonusRateEdit(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();    
                                    self.$bvModal.hide('editBonusRate');        
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    })
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                } 
            }
        },getToolList(){
            var self = this;
            var result = this.$general.getToolList();
            result.then(function(value){
                self.ajaxToolList = value.data;
            });
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id;
            if(row.status != 0){
                this.showEdit = false;
            }
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
        this.getToolList();
    }
}
</script>
